import React, { useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DomainContext from "Context/DomainContext";
import { APIQueryPost } from "APIMethods/API";
import { getCartItems, SessionExpiredLogout } from "Utilities";
import useForm from "Components/Hooks/useForm";
import Button from "Components/Common/Button";
import Input from "Components/Common/Form/Input";
import { ValidSuccesArrow, ValidErrorArrow } from "Res/icons/index";
// commented for purpose   as its functionality is commended below
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CircularProgress from "@mui/material/CircularProgress";
import "./styles.scss";
import { useTranslation } from 'react-i18next';

function ApplyCouponSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { baseURL, storeId, defaultURL } = useContext(DomainContext);

  const {
    cartDetails,
    guestQuoteId,
    customerQuoteId,
    customerId,
    isLoggedUser,
    isSessionExpired,
    token,
  } = useSelector((state) => ({
    cartDetails: state?.cartItems?.[0],
    guestQuoteId: state?.guestQuoteDetails?.id,
    customerQuoteId: state?.customerQuoteId,
    isLoggedUser: state?.isLoggedUser,
    customerId: state?.customerDetails?.id,
    token: state?.token,
    isSessionExpired: state?.isSessionExpired,
  }));

  const {
    data,
    errors,
    setErrors,
    changeHandler,
    onBlur,
  } = useForm({
    validations: {
      couponInput: {
        required: {
          value: cartDetails?.totals_detail?.couponCode === null,
          message: "dit veld is verplicht.",
        },
      },
    },
    onSubmit: () => handleCoupon(),
  });

  const [coupon, setCoupon] = useState(null);
  const [toggleCoupon, setToggleCoupon] = useState(false);
  const [couponMessage, setCouponMessage] = useState("");
  const [validCouponCode, setValidCouponCode] = useState(0);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const currentQuoteId = isLoggedUser ? customerQuoteId : guestQuoteId;

  const refreshCart = () => {
    getCartItems(
      dispatch,
      () => {},
      currentQuoteId,
      isLoggedUser ? customerId : "",
      () => {},
      defaultURL,
      storeId,
      token,
      navigate,
      isSessionExpired
    );
  };

  const handleResponse = (resData) => {
    const message = resData?.data?.[0]?.message || "";
    const code = resData?.data?.[0]?.code || 0;

    setCouponMessage(message);
    setLoading(false);

    if (code === 200) setValidCouponCode(1);
    else if (code === 400) setValidCouponCode(2);
    else setValidCouponCode(3);
  };

  const applyCouponCode = () => {
    APIQueryPost({
      isLoader: true,
      loaderAction: setLoading,
      setGetResponseData: (resData) => {
        handleResponse(resData);
        if (resData?.status === 200) refreshCart();
      },
      getStatus: (res) => SessionExpiredLogout(dispatch, res?.status, navigate, isSessionExpired),
      axiosData: {
        url: `${baseURL}/coupon/apply`,
        paramsData: {
          data: {
            customerId: customerId || "",
            quoteId: currentQuoteId,
            couponCode: coupon,
            storeId,
          },
        },
      },
    });
  };

  const deleteCouponCode = () => {
    setCoupon("");
    APIQueryPost({
      isLoader: true,
      loaderAction: setLoading,
      setGetResponseData: (resData) => {
        handleResponse(resData);
        if (resData?.status === 200) refreshCart();
      },
      getStatus: (res) => SessionExpiredLogout(dispatch, res?.status, navigate, isSessionExpired),
      axiosData: {
        url: `${baseURL}/coupon/remove`,
        paramsData: {
          data: {
            customerId: customerId || "",
            quoteId: currentQuoteId,
            couponCode: "",
            storeId,
          },
        },
      },
    });
  };

  const handleCoupon = () => {
    cartDetails?.totals_detail?.couponCode ? deleteCouponCode() : applyCouponCode();
  };

  const hasAppliedCoupon = !!cartDetails?.totals_detail?.couponCode;

  return (
    <div className="flex w-1/1 pb-6 coupon__section">
      <div className="flex-1 xl-pt-0">
          <span className="no-translate notranslate fs-15 fw-700">{t("Kortingscode")}</span>
          <div
            className={`w-1/1 pt-4 ${
              couponMessage
                ? validCouponCode === 1 && hasAppliedCoupon
                  ? "success"
                  : validCouponCode === 2
                  ? "fail"
                  : validCouponCode === 3
                  ? "input"
                  : ""
                : ""
            }`}
          >
            <Input
              name="couponInput"
              placeHolder="Vul uw kortingscode in"
              value={hasAppliedCoupon ? cartDetails?.totals_detail?.couponCode : coupon}
              disabled={hasAppliedCoupon}
              onChange={(e) => {
                setCoupon(e.target.value);
                setCouponMessage("");
                changeHandler(e);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleCoupon();
                }
              }}
              onBlur={() => onBlur("couponInput")}
              errorMessage={
                errors?.couponInput === data?.couponInput ? "" : errors?.couponInput
              }
              icon={
                couponMessage
                  ? validCouponCode === 1 && hasAppliedCoupon
                    ? <ValidSuccesArrow role="presentation"  />
                    : validCouponCode === 2
                    ? <ValidErrorArrow role="presentation"  />
                    : ""
                  : ""
              }
              showIcon={true}
              className="pb-5"
            />

            <p  className={`py-2 fs-15 ${validCouponCode === 1 ? "success" : ""}`}>
              {couponMessage}
            </p>

            <Button
              className={`fs-15 line-8 fw-700 r-7 px-5  coupon__button`}
              fullWidth
              type="submit"
              onClick={handleCoupon}
            >
              {loading ? (
                <CircularProgress size={24} thickness={4} color="error" />
              ) : hasAppliedCoupon ? <span className="no-translate notranslate">{t("Verwijderen")}</span>  : <span className="no-translate notranslate">{t("Toevoegen")}</span> }
            </Button>
          </div>
        {/* )} */}
      </div>
    </div>
  );
}

export default ApplyCouponSection;
